import React from 'react'
import { useHistory } from 'react-router-dom'

const InvalidRoute = () => {
  const history = useHistory()
  return (
    <div className='d-flex container-404-page align-self-center'>
      <div className='main'>
        <h4 className='title-404'>
          <div>Our feathers are</div>
          <div>a bit ruffled.</div>
        </h4>
        <p className='para-404 mb-0'> Sorry, but it looks like this <span>page is missing.</span></p>
        <button className='btn btn-homepage' onClick={() => history.push('/')}> Go to Homepage </button>
      </div>
    </div>
  )
}

export default InvalidRoute
